import { Component, Inject, ViewChild } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HirNavComponent } from '../hir-nav/hir-nav.component';
import { HirPolicyPermissionsService } from '../../shared/core-hir/hir-policy-permissions.service';

@Component({
  selector: 'hir-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})
export class HirHomeComponent {
  @ViewChild(HirNavComponent) hirNavComponent: HirNavComponent;

  programItems: any = [];

  constructor(
    @Inject('APP_PATH') public appPath: string,
    private _title: Title,
    private policyPermissionsService: HirPolicyPermissionsService) {
    this._title.setTitle("Home - HIR");
  }

  onInitializePrograms(event) {
    this.initializeProgramItems(event);

    let bpb = document.querySelector('[bypass-block]');
    if (bpb instanceof HTMLElement) {
      bpb.focus();
      bpb.blur();
    }
  }

  initializeProgramItems(tabs: any) {
    let programItems = [
      { name: "Deployments", url: "/hir/deployments", iconClass: "pi pi-calendar", accessible: this.hasDeploymentsTab(tabs['deployments']) },
      { name: "Patients", url: "/hir/patients", iconClass: "glyphicon glyphicon-user", accessible: this.hasPatientsTab(tabs['patients']) },
      { name: "Responders", url: "/hir/responders", iconClass: "pi pi-user", accessible: this.hasRespondersTab(tabs['responders']) }
    ];
    this.programItems = programItems.filter(i => i.accessible);
  }

  private hasDeploymentsTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Hir:Deployment:Access']);
  }

  private hasPatientsTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Hir:Patient:Access']);
  }

  private hasRespondersTab(tab) {
    return this.policyPermissionsService.hasAnyPermissions(['Hir:Responder:Access']);
  }

  onMainContentClick() {
    let mc = document.querySelector('[main-content]');
    if (mc instanceof HTMLElement) {
      mc.focus();
      mc.blur();
    }
  }
}
